export const faqData = [
    {
        id: "01",
        question:
            "How much does it cost to build a mobile app and how do we estimate the cost?",
        answer: [
            {
                type: "paragraph",
                content: "The cost to build a mobile app varies greatly due to the endless possibilities and innovative ideas that each project brings. As a baseline, a project starts at $3,000 for a basic app or the prototyping of an idea."
            },
            {
                type: "paragraph",
                content: "To provide a detailed estimate, we evaluate the number of resources required, such as project managers, designers, developers, QA specialists, and DevOps engineers, along with the minimum number of working-hours required by each resource. The final cost is determined by the app's technical difficulty and development effort. We then structure the total effort and cost into progressive milestones to ensure transparency and manageable payments throughout the development lifecycle."
            }

        ],
    }, {
        id: "02",
        question: "How can I monetize a mobile app and make money from my mobile app idea?",
        answer: [
            {
                type: "paragraph",
                content: "There are several effective strategies to monetize a mobile app, and the best approach often depends on your app's purpose and audience. Popular methods include:",
            },
            {
                type: "list",
                list: [
                    "In-app advertisements: Displaying ads from various networks.",
                    "In-app purchases: Selling goods or services within the app.",
                    "Paid downloads of apps: Offering the app for a one-time fee.",
                    "Paid features or Subscription models/tiers: Charging a recurring fee for access to premium content or services.",
                    "Commissions: Taking a percentage of sale/earning commissions from users for transactions facilitated by your app.",
                    "Affiliate models: Earning revenue by promoting other businesses' products or services."
                ]
            }
        ]
    }, {
        id: "03",
        question: "Do I need to hire a developer to build my app?",
        answer: [
            {
                type: "paragraph",
                content: 'For a complete beginner, one of the biggest challenges is the steep learning curve required to learn app development. While many search for an "App development tutorial" and explore No-code app development, these platforms often have limitations. For non-technical users and vibe-coding enthusiasts, an individual effort can result in non-scalable MVPs that face significant technical challenges.'
            },
            {
                type: "paragraph",
                content: "To build from scratch professionally, you must master the tools professional mobile developers use and often need to delve into the nuances in iOS or Android development. Building a quality app requires a team of relevant experts who can solve complex debugging issues, and can navigate critical concerns like system design, data privacy and security issues."
            }
        ]


    }, {
        id: "04",
        question: "How do I choose the right company or developers to build my app?",
        answer: [
            {
                type: "paragraph",
                content: 'Choosing the right partner is crucial. First, verify the legitimacy of the company, review their portfolio and ask for examples of actually deployed apps. A professional firm will have clear policies and protocols to secure your app idea and will be ready to sign agreements to manage intellectual property and confidentiality.'
            },
            {
                type: "paragraph",
                content: 'A strong partner will prioritize correctly validating technical feasibilities before commencement. They should also be capable of implementing a proof of concept for core functionalities to test the idea effectively. Finally, ensure they present a clear and robust plan for the overall system design to demonstrate a solid understanding for your project.'
            }]
    }
    , {
        id: "05",
        question: "How can I prototype or build an MVP and then scale my app? ",
        answer: [
            {
                type: "paragraph",
                content: 'The process begins with creating a functionality and work-flow depicting UI/UX prototype. This allows you to visualize and test the user journey without the cost of full development.'
            },
            {
                type: "paragraph",
                content: "Next, we develop an MVP (Minimum Viable Product) version with core-features. Critically, this MVP is built on platforms and architecture that ensure it's scalable for future growth. This strategy allows you to launch quickly, and then you can scale the prototype or MVP upon positive reinforcement from early adopters, which is measured through key metrics like revenue generation and user feedback. "
            }]
    }

];